import React from 'react';
import { TabsEnum } from '../enums/enums';
import { LoginGigyaInterface } from '@/shared/interfaces/LoginGigyaInterface';
import { UserInfo } from '../interfaces/userInfo';

export interface GlobalContextInterface {
    fontSize?: { get: number; set: (size: number) => void };
    superFooter?: { get: boolean; set: (value: boolean) => void };
    selectedTab?: { get: TabsEnum; set: (tab: TabsEnum) => void };
    selectedService?: { get: ServiceTab; set: (service: ServiceTab) => void };
    business?: {
        get: DropdownElementInterface | undefined;
        set: (value: DropdownElementInterface | undefined) => void;
    };
    userVerificationData?: {
        get: UserVerificationDataInterface | undefined;
        set: (value: UserVerificationDataInterface | undefined) => void;
    };

    checkPermissionPage?: {
        has: boolean;
        get: string;
        set: (serviceID: string) => void;
    };
    gigyaContext: LoginGigyaInterface;
    userInfoContext: UserInfo;
}
interface ServiceTab {
    service: string;
    category: string;
    index: number;
}

interface DropdownElementInterface {
    authorizingUser: string;
    companyDocID: string;
    companyDocType: string;
    date: string;
    label: string;
    serviceId: string;
}
interface UserVerificationDataInterface {
    bp: number;
    id: number;
    idType: any;
    fullName: string;
    birthDate: any;
    age: number;
    gender: string;
    salarialCategory: string;
    afiliatedGroup: string;
    monetaryFeeValue: any;
    status: string;
    statusCause: any;
    fee: any;
    simultaneousCompanies: number;
    companyAdmissionDate: any;
    expirationDate: any;
    effectiveStartDate: any;
    contributionPercentaje: string;
    salaryType: string;
    cardNumber: number;
    cardStatus: string;
    cardLot: number;
    civilStatus: number;
    businessList?: UserBusinessListInterface[];
    beneficiaries?: UserBeneficiariesInterface[];
}

interface UserBusinessListInterface {
    bp: number;
    id: number;
    idType: string;
    businessName: string;
    status: string;
    mainBusiness: string;
    group: any;
    location: any;
    bussinesAdmissionDate: any;
    bussinesExpirationDate: any;
    bussinesEffectiveStartDate: any;
}
interface UserBeneficiariesInterface {
    bp: number;
    id: number;
    idType: string;
    fullName: string;
    age: number;
    gender: string;
    relationship: string;
    relationshipDescription: string;
    birthDate: any;
    comfamaDate: any;
    expirationDate: any;
    fee: string;
    salarialCategory: string;

    // afiliatedGroup: string;
    // monetaryFeeValue: any;
    // status: string;
    // statusCause: any;
    // simultaneousCompanies: number;
    // effectiveStartDate: any;
    // position: number;
    // salaryType: number;
    // cardNumber: number;
    // cardStatus: string;
    // cardLot: number;
    // civilStatus: number;
    // businessList: UserBusinessListInterface[];
    // beneficiaries: any;
}

const context: GlobalContextInterface = {
    gigyaContext: {
        login: () => null,
        loginComfamaId: () => null,
        logout: () => null,
        updateProfile: () => null,
        register: () => null,
        gigyaAccount: undefined,
        showScreen: () => null,
        updateProfilePhoto: () => null,
        isLoadingGigya: true,
    },
    userInfoContext: {},
};

const GlobalContext = React.createContext(context);

export default GlobalContext;
